import { Button, Typography, Box, Stack } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { useIsMobile } from '@/hooks/Responsive'
import { useLang } from '@/i18n/useLang'
import { buildLangHref } from '@data/nav'

export default function ResetPasswordLater() {
  const { isMobile } = useIsMobile()
  const lang = useLang()
  return (
    <Box>
      <Typography component="h3" variant={isMobile ? 'h6' : 'h5'} sx={{ mb: 7 }}>
        비밀번호 재설정
      </Typography>

      <Stack
        spacing={1.5}
        alignItems="center"
        justifyContent="center"
        sx={{ 
          bgcolor: 'grey.50',
          borderRadius: 4,
          minHeight: '160px',
          py: 3,
          px: 4,
        }}
      >
        <Typography component="p" sx={{ textAlign: 'center' }}>
          비밀번호가 재설정 되었습니다.<br />
          새로운 비밀번호로 로그인 하실 수 있습니다.
        </Typography>
      </Stack>

      <Stack direction="row" spacing={1} sx={{ mt: 5 }}>
        <Button component={RouterLink} to={buildLangHref('/', lang)} size="large" variant="outlined" color="primary" sx={{ flex: 1 }}>홈</Button>
        <Button component={RouterLink} to={buildLangHref('/login', lang)} size="large" variant="contained" color="primary" sx={{ flex: 1 }}>로그인</Button>
      </Stack>
    </Box>
  )
}